import React from 'react';
import I18n from '@/modules/i18n';
import FullWidthCard from '@/components/shared/NewLessonOverview/Cards/Card/FullWidthCard';
import { present_mode_shared_slide_show_path } from '@/modules/routes';
import Icon from './Icon';
import type { SlideShow } from './UnitSlideShowCardTypes';

interface UnitSlideShowCardProps {
  programId: number;
  slideShow: SlideShow;
  unitColor: string;
  unitId: number;
}

const UnitSlideShowCard = ({ programId, slideShow, unitColor, unitId }: UnitSlideShowCardProps) => {
  const text = I18n.locale === 'es' && slideShow.title_es ? slideShow.title_es : slideShow.title_en;

  return (
    <FullWidthCard
      Icon={(
        <Icon className="tw-text-dark-grey" slideShow={slideShow} />
      )}
      isStaffer={false}
      page={slideShow.page}
      presentPath={present_mode_shared_slide_show_path(slideShow.id, {
        from: 'Unit',
        parent_id: unitId,
        parent_type: 'Unit',
        program_id: programId,
      })}
      title={text}
      unitColor={unitColor}
    />
  );
};

export default UnitSlideShowCard;
